const store = {
  organization: {},
  testing_organization: {},
  testing: {
    strategies: [],
  },
  sites: [],
  articles: {},
  subscriptions: {},
  statistics: {},
};

window.store = store;
export default store;



// WEBPACK FOOTER //
// ./src/js/store.js